import { gql } from '@apollo/client';

export const LIST_CHANNEL_MONETIZATION_PROGRAMS = gql`
  query ListChannelMonetizationPrograms {
    listChannelMonetizationPrograms {
      id
      monthLabel
      prizeAmount
      prizeCurrency
      slotsPerMonth
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_CHANNEL_MONETIZATION_LEADERBOARD_ADMIN = gql`
  query GetChannelMonetizationLeaderboardAdmin(
    $input: GetChannelMonetizationAdminLeaderboardInput!
  ) {
    getChannelMonetizationLeaderboardAdmin(input: $input) {
      monthLabel
      total
      offset
      limit
      entities {
        storeId
        storeName
        avatarUrl
        completedSteps
        totalSteps
        overallPercent
      }
    }
  }
`;

export const LIST_CHANNEL_MONETIZATION_MILESTONES = gql`
  query ListChannelMonetizationMilestones($programId: String!) {
    listChannelMonetizationMilestones(programId: $programId) {
      id
      programId
      type
      target
      enabled
      displayOrder
    }
  }
`;

export const GET_CHANNEL_MONETIZATION_APPLICATION_CONTENT = gql`
  query GetChannelMonetizationApplicationContent($applicationId: String!) {
    getChannelMonetizationApplicationContent(applicationId: $applicationId) {
      monthLabel
      followersCount
      interviewStreams {
        id
        label
        url
        kind
        date
      }
      interviewNow {
        id
        label
        url
        kind
        date
      }
      mentions {
        id
        label
        url
        kind
        date
      }
      guestInvites {
        id
        label
        url
        kind
        date
      }
    }
  }
`;

export const GET_CHANNEL_MONETIZATION_LEADERBOARD_CONTENT = gql`
  query GetChannelMonetizationLeaderboardContent(
    $input: GetChannelMonetizationLeaderboardContentInput!
  ) {
    getChannelMonetizationLeaderboardContent(input: $input) {
      monthLabel
      followersCount
      milestones {
        type
        label
        current
        target
        percent
        completed
      }
      interviewStreams {
        id
        label
        url
        kind
        date
      }
      interviewNow {
        id
        label
        url
        kind
        date
      }
      mentions {
        id
        label
        url
        kind
        date
      }
      guestInvites {
        id
        label
        url
        kind
        date
      }
    }
  }
`;

export const LIST_CHANNEL_MONETIZATION_APPLICATIONS = gql`
  query ListChannelMonetizationApplications(
    $input: ListChannelMonetizationApplicationsInput!
  ) {
    listChannelMonetizationApplications(input: $input) {
      entities {
        id
        storeId
        monthLabel
        status
        submittedAt
        reviewedAt
        reviewerId
        rejectionReason
        targetSnapshots {
          type
          target
        }
        prizeAmountSnapshot
        store {
          id
          firstName
          lastName
          avatarUrl
          storeDetails {
            id
            storeName
          }
        }
      }
      total
      offset
      limit
    }
  }
`;
